export default "__VITE_PUBLIC_ASSET__4beee593__"